import { InfiniteData, QueryClient } from '@tanstack/react-query';

import { ResultListModel } from '@common-lib';

import { TransactionV2ListModel } from '@portal-clients/transaction-v2';

/**
 * Looks for a transaction with the given id in any already-cached account
 * transaction list. Used to seed the transaction detail query's placeholder
 * data so revisiting (or first visiting) a transaction whose status/summary
 * was already updated live in the list never flashes the previous state
 * while the detail GET request is in flight.
 */
export const findTransactionInAccountListsCache = (
  queryClient: QueryClient,
  id: string,
): TransactionV2ListModel | undefined => {
  const cachedLists = queryClient.getQueriesData<
    InfiniteData<ResultListModel<TransactionV2ListModel>>
  >({ queryKey: ['transactions'] });

  for (const [, data] of cachedLists) {
    for (const page of data?.pages ?? []) {
      const match = page.results.find((transaction) => transaction.id === id);

      if (match) {
        return match;
      }
    }
  }

  return undefined;
};
